// action types
import { createRequestTypes } from "../../utils";

export const FETCH_COUNTRIES = createRequestTypes("FETCH_COUNTRIES");

export const fetchCountriesRequest = () =>
    ({ type: FETCH_COUNTRIES.REQUEST });

export const fetchCountriesSuccess = (countries, count) =>
    ({ type: FETCH_COUNTRIES.SUCCESS, payload: { countries, count } });

export const fetchCountriesFailure = (error) =>
    ({ type: FETCH_COUNTRIES.FAILURE, payload: { error } });